import Button from "react-bootstrap/Button";

import { Icon, ModalWrapper } from "@components";
import { EnrichedFile } from "@modules/network/@types/common";

interface BulkActionConfirmModalProps {
  actionLabel: string;
  applicableSamples: EnrichedFile[];
  nonApplicableSamples: EnrichedFile[];
  onConfirm: () => void;
  onClose: () => void;
}

const BulkActionConfirmModal = ({
  actionLabel,
  applicableSamples,
  nonApplicableSamples,
  onConfirm,
  onClose
}: BulkActionConfirmModalProps) => (
  <ModalWrapper
    title={actionLabel}
    onHide={onClose}
    data-testid="bulk-action-confirm-modal"
    footer={
      <>
        <Button
          variant="prompt-secondary"
          onClick={onClose}
          data-testid="bulk-action-confirm-modal-cancel"
        >
          Cancel
        </Button>
        <Button
          variant="prompt-primary"
          onClick={onConfirm}
          data-testid="bulk-action-confirm-modal-proceed"
        >
          Proceed
        </Button>
      </>
    }
  >
    <p>
      This action applies to {applicableSamples.length} of{" "}
      {applicableSamples.length + nonApplicableSamples.length} selected samples.
    </p>
    <h4>Will apply to:</h4>
    <ul>
      {applicableSamples.map(({ sha1, sha256, location }) => (
        <li key={sha1} data-testid={`bulk-action-confirm-applicable-${sha1}`}>
          <Icon
            name={location === "local" ? "local" : "cloud"}
            className="me-5"
          />
          {sha256 ?? sha1}
        </li>
      ))}
    </ul>
    <h4>Will not apply to:</h4>
    <ul>
      {nonApplicableSamples.map(({ sha1, sha256, location }) => (
        <li
          key={sha1}
          data-testid={`bulk-action-confirm-nonapplicable-${sha1}`}
        >
          <Icon
            name={location === "local" ? "local" : "cloud"}
            className="me-5"
          />
          {sha256 ?? sha1}
        </li>
      ))}
    </ul>
  </ModalWrapper>
);

export default BulkActionConfirmModal;
